import { RESET } from 'action-creators/generic';
import {
  GroupActions,
  LOAD_GROUP_LIST,
  UPDATE_GROUP,
  DELETE_GROUP,
  CREATE_GROUP,
  LOAD_GROUP_REQUEST,
} from 'action-creators/group';
import { Group } from 'models/group';

export interface GroupState {
  groupList: Group[];
  isLoading: boolean;
}

const initialState: GroupState = {
  groupList: [],
  isLoading: false,
};

const reducer = (state = initialState, action: GroupActions): GroupState => {
  switch (action.type) {
    case LOAD_GROUP_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case LOAD_GROUP_LIST: {
      return {
        ...state,
        groupList: action.groupList,
        isLoading: false,
      };
    }
    case UPDATE_GROUP: {
      return {
        ...state,
        groupList: state.groupList.map((cCode) => (cCode.id === action.group.id ? action.group : cCode)),
      };
    }
    case CREATE_GROUP: {
      return {
        ...state,
        groupList: state.groupList.concat([action.group]),
      };
    }
    case DELETE_GROUP: {
      return {
        ...state,
        groupList: state.groupList.filter((cCode) => cCode.id !== action.group.id),
      };
    }
    case RESET:
      return initialState;
    default:
      return state;
  }
};

export default reducer;
